import client from "./client";

export function prepareLogos(form = {}) {
  return {
    logosTitle1: form.logosTitle1 ?? "",
    logosTitle2: form.logosTitle2 ?? "",
    logos: (form.logos || []).map((logo) => String(logo || "")).filter(Boolean),
    logosHide: !!form.logosHide,
  };
}

export const getLogosSection = () => client.post("/logossection/get");
export const addLogosSection = (payload) =>
  client.post("/logossection/add", payload);
export const updateLogosSection = (payload) =>
  client.post("/logossection/update", payload);
export const deleteLogosSection = () => client.post("/logossection/delete");
